import script from "./HintsViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./HintsViewer.vue?vue&type=script&setup=true&lang=ts"

import "./HintsViewer.vue?vue&type=style&index=0&id=4fa188ab&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa188ab"]])

export default __exports__